import React from 'react';
import { Container, Input, Link, Stack, Text } from 'basis';
import { FormValidateOptions } from 'components';

const NUMERIC_REGEX = /^\d*$/;

function validate(value: string, { isEmpty, data }: FormValidateOptions) {
  if (isEmpty(value)) {
    return `Please enter your ${data.codeLength} code`;
  }
  const trimmedValue = value.trim();
  if (NUMERIC_REGEX.test(trimmedValue) === false) {
    return 'Only 0-9 are allowed';
  }
  const codeLength = Number(data.codeLength);
  if (trimmedValue.length !== codeLength) {
    return `Must have ${codeLength} digits`;
  }
  return null;
}

type Props = {
  maskedMobileNumber: string;
  name: string;
  label: string;
  codeLength: number;
  loading: boolean;
  state: string;
  onResendCodeClick: (evt: React.SyntheticEvent<HTMLAnchorElement>) => void;
};

export const BasisOneTimeCode: React.FC<Props> = ({
  maskedMobileNumber,
  name = 'oneTimeCode',
  label = 'Verification code',
  codeLength = 6,
  loading,
  state,
  onResendCodeClick,
}) => {
  return (
    <Stack gap="8">
      <Text>
        We’ve just sent an SMS verification code to <strong>{maskedMobileNumber.replace(/[X*]/gi, '•')}</strong>.
        <br />
        Please enter the {codeLength} digit code.
      </Text>
      <Stack gap="2">
        <Input
          name={name}
          label={label}
          variant="numeric"
          maxLength={codeLength}
          autoComplete="one-time-code"
          validate={validate}
          validateData={{ codeLength }}
          testId="verification-code"
        />
        <Container textStyle="body2">
          <Stack gap="2" direction="horizontal">
            <Text>Not received your code yet?</Text>
            {loading || state === 'PENDING' ? (
              <Text>
                <strong>Sending...</strong>
              </Text>
            ) : state === 'SUCCESS' ? (
              <Text color="conditional.positive.text">
                <strong>Code sent</strong>
              </Text>
            ) : state === 'ERROR' ? (
              <Text color="conditional.negative.text">
                <strong>Error sending, please wait...</strong>
              </Text>
            ) : (
              <Text textStyle="body2">
                <Link href="" newTab={false} onClick={onResendCodeClick}>
                  Resend code
                </Link>
              </Text>
            )}
          </Stack>
        </Container>
      </Stack>
    </Stack>
  );
};
